import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CommonStateService } from '../../../state';
import { AuthService } from '../../shared/auth.service';

@Component({
    selector: 'cal-user-info-modal',
    templateUrl: './user-info-modal.component.html',
    styleUrls: ['./user-info-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserInfoModalComponent {
    @Input()
    profile: any;
    resources: any;

    constructor(private activeModal: NgbActiveModal,
        private commonService: CommonStateService,
        private authService: AuthService) {
        this.resources = this.commonService.getResources();
    }

    close() {
        this.activeModal.close();
    }

    logout() {
        this.activeModal.close();
        this.authService.logout();
    }
}
